<template>
  <b-modal id="reply-message" ref="reply-message-modal" centered hide-footer>
    <div style="padding: 25px;">
      <div
        style="font-size: 24px; font-weight: 500; text-align: center; padding-bottom: 24px;"
      >
        Reply Message
      </div>
      <div>
        <b-form-group label="Subject" label-for="subject">
          <b-form-select
            id="subject"
            :options="subjects"
            disabled
            :value="subject"
            @change="onChange($event, 'subject')"
          />
        </b-form-group>
      </div>
      <div class="mt-2">
        <label for="textarea-default">Message</label>
        <b-form-textarea
          id="message"
          placeholder="Type message here"
          rows="4"
          :value="message"
          @change="onChange($event, 'message')"
        />
      </div>

      <div class="mb-0 text-center mt-2">
        <!-- basic -->
        <b-button variant="primary" @click="sendReply">Reply Message</b-button>
        <b-button variant="outline-secondary" class="ml-1" @click="closeModal"
          >Discard</b-button
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
/* eslint-disable */
import {
  BTable,
  //   BFormCheckbox,
  BCard,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BImg,
  BFormInput,
  BModal,
  BButton,
  BFormSelect,
  BBadge,
  BFormTextarea,
  BPagination,
} from "bootstrap-vue";
import { replyMessage } from "@/service/api.service";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BTable,
    // BButton,
    // BFormCheckbox,
    BFormSelect,
    BFormGroup,
    BFormInput,
    BButton,
    BCard,
    BRow,
    BModal,
    BImg,
    BCol,
    BBadge,
    BAvatar,
    BPagination,
    BFormTextarea,
  },

  data() {
    return {
      categories: [{ text: "Standard", value: "STANDARD" }],
      subject: null,
      message: "",
      subjects: [
        { text: "Select subject", value: null },
        { text: "Welcome", value: "1" },
        { text: "Withdrawal Issue", value: "2" },
        { text: "Donation Issue", value: "3" },
        { text: "Fundraiser Issue", value: "4" },
        { text: "Profile Issue", value: "5" },
        { text: "Technical Issue", value: "6" },
        { text: "Suggestion", value: "7" },
        { text: "Other", value: "8" },
      ],
    };
  },

  props: {
    messageData: {
      type: Object,
    },
    threadId: {
      type: String,
    },
  },

  created() {
    const subjectId = Object.keys(this.messageData)[0];
    this.subject = `${subjectId}`;
  },

  methods: {
    onChange(value, id) {
      this[id] = value;
    },
    sendReply() {
      const dt = Object.values(this.messageData)[0];
      const payload = {
        subjectId: +this.subject,
        message: this.message,
        sender: 1,
        recepient: 2,
        messageId: this.threadId,
        userId: this.$route.params.userId,
      };
      replyMessage(payload)
        .then((res) => res.json())
        .then((response) => {
          if (response.valid) {
            this.message = "";
            this.$emit("refresh");
            this.showToast("Success", "success", response.message);
            this.closeModal();
          } else {
            this.showToast("Error", "danger", response.message);
          }
        })
        .catch(e => this.showToast("Error", "danger", e))
    },
    closeModal() {
      this.$nextTick(() => {
        this.$refs["reply-message-modal"].toggle("#toggle-btn");
      });
    },
    showToast(title, variant, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          text: text,
          icon: title === "Error" ? "TrashIcon" : "DoneIcon",
          variant: variant,
        },
      });
    },
  },
};
</script>

<style scoped></style>
